import { Icon } from '~/shared/components/Icon';
import {
  CloseButton,
  CloseButtonWrapper,
} from '~/shared/components/Ticket/Dialog/style';

type CloseDialogButtonProps = {
  onClick?: () => void;
};
export function CloseDialogButton({ onClick }: CloseDialogButtonProps) {
  return (
    <CloseButtonWrapper>
      <CloseButton type="button" onClick={onClick}>
        <Icon icon="close" isCustom />
      </CloseButton>
    </CloseButtonWrapper>
  );
}
